
import React from 'react';
import { MLTrainingDashboard } from '@/components/admin/MLTrainingDashboard';

export default function MLTraining() {
  return (
    <div className="container mx-auto py-8">
      <MLTrainingDashboard />
    </div>
  );
}
